export default "__VITE_ASSET__C3y2bdpF__"